import { h } from 'preact';

export function IconFilm({ width = 22, height = 22, fill = 'currentColor' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 640 640"
      width={width}
      height={height}
      class="icon-film"
    >
      <path
        d="M256 496L384 496L384 144L256 144L256 496zM208 144L160 144C151.2 144 144 151.2 144 160L144 192L208 192L208 144zM208 240L144 240L144 296L208 296L208 240zM208 344L144 344L144 400L208 400L208 344zM208 448L144 448L144 480C144 488.8 151.2 496 160 496L208 496L208 448zM432 144L432 192L496 192L496 160C496 151.2 488.8 144 480 144L432 144zM496 240L432 240L432 296L496 296L496 240zM496 344L432 344L432 400L496 400L496 344zM496 448L432 448L432 496L480 496C488.8 496 496 488.8 496 480L496 448zM160 96L480 96C515.3 96 544 124.7 544 160L544 480C544 515.3 515.3 544 480 544L160 544C124.7 544 96 515.3 96 480L96 160C96 124.7 124.7 96 160 96z"
        fill={fill}
      />
    </svg>
  );
}